import React, { useEffect } from "react";
import styled from "styled-components";

// 스타일 컴포넌트 정의
const Styled = {
  // 전체 래퍼 - 상단 바 역할
  Wrap: styled.div`
    width: 100%;
    height: 56px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: row;
    background-color: #ffffff;
  `,
  // 스크롤 가능한 카테고리 버튼 리스트 영역
  AnchorWrap: styled.div`
    width: 82%;
    height: 50px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-direction: row;
    overflow-x: auto;
    white-space: nowrap;
    -webkit-overflow-scrolling: touch;

    scrollbar-width: none; // Firefox용 스크롤바 숨김
    &::-webkit-scrollbar {
      display: none; // Chrome, Safari용 스크롤바 숨김
    }
  `,
  // 각 카테고리 버튼 박스
  AnchorBox: styled.div`
    width: 84px;
    height: 35px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: row;
    border-radius: 17px;
    margin-right: 5px;
    padding: 0px 5px;
    border: ${(props) => (props.selected ? "1px solid #B5B5B5" : "1px solid #B5B5B5")};
    background-color: ${(props) => (props.selected ? "#000000" : "transparent")}; // 선택된 경우 배경색 검정
  `,
  // 버튼 안의 텍스트
  AnchorText: styled.p`
    font-size: 14px;
    margin: 0px;
    font-family: 'PreFont';
    font-weight: 400;
    color: ${(props) => (props.selected ? "#ffffff" : "#B5B5B5")}; // 선택된 경우 텍스트 흰색
  `,
};

// Anchor 컴포넌트 정의
const Anchor = (props) => {
  const { CateGori, RestaurantInfo } = props;

  // 카테고리 이름 배열 추출
  const menuItems = RestaurantInfo.categories.map(item => item.names.KR);

  // 특정 id를 가진 섹션으로 스크롤하는 함수
  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      const headerHeight = 80; // 고정된 헤더의 높이만큼 보정
      const offset = element.offsetTop - headerHeight;
      window.scrollTo({
        top: offset,
        behavior: "smooth", // 부드럽게 스크롤
      });
    }
  };

  return (
    <Styled.Wrap>
      <Styled.AnchorWrap>
        {/* 각 카테고리를 AnchorBox로 렌더링 */}
        {menuItems.map((item, index) => (
          <Styled.AnchorBox
            key={index}
            selected={CateGori === item} // 현재 선택된 카테고리 여부
            onClick={() => scrollToSection(item)} // 클릭 시 해당 섹션으로 스크롤
          >
            <Styled.AnchorText selected={CateGori === item}>
              {item}
            </Styled.AnchorText>
          </Styled.AnchorBox>
        ))}
      </Styled.AnchorWrap>
    </Styled.Wrap>
  );
};

export default Anchor;
